import React from 'react';
import { Link } from 'react-router-dom';
import './Homework4.css';

const Homework4: React.FC = () => {
  const questions = [
    {
      id: 1,
      title: 'Salt-and-Pepper Noise Reduction',
      description: 'Apply spatial filters (min, max, average, median) to reduce noise',
      path: '/homework/4/question1',
      color: '#3b82f6'
    },
    {
      id: 2,
      title: 'Bone Scan Enhancement',
      description: '8-step image enhancement procedure using edge detection and sharpening',
      path: '/homework/4/question2',
      color: '#10b981'
    }
  ];

  return (
    <div className="homework4-container">
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="content-wrapper">
        <Link to="/" className="back-button">
          ← Back to Hub
        </Link>

        <header className="homework4-header">
          <div className="badge">Homework 4</div>
          <h1>Spatial Filtering & Enhancement</h1>
          <p className="subtitle">Noise Reduction and Multi-Step Image Enhancement</p>
        </header>

        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🔧</span>
            <h3>Spatial Filters</h3>
            <p>Min, max, average, and median filters for noise reduction</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📐</span>
            <h3>Edge Detection</h3>
            <p>Laplacian and Sobel operators for edge enhancement</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚙️</span>
            <h3>Manual Implementation</h3>
            <p>All algorithms built from scratch with nested loops</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎯</span>
            <h3>Multi-Step Processing</h3>
            <p>8-step enhancement pipeline for bone scan images</p>
          </div>
        </div>

        <div className="questions-section">
          <h2>Select a Question</h2>
          <div className="questions-grid">
            {questions.map((question) => (
              <Link
                key={question.id}
                to={question.path}
                className="question-card"
                style={{ '--card-color': question.color } as React.CSSProperties}
              >
                <div className="question-number">Q{question.id}</div>
                <h3>{question.title}</h3>
                <p>{question.description}</p>
                <div className="card-arrow">→</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homework4;
